import { create } from "zustand";
import { COOKIE_LOCAL_STORAGE_ID } from "../constants/cookieBanner";

interface CookieBannerStoreI {
  isCBVisible: boolean;
  hasConsent: boolean;
  showCookieBanner: () => void;
  hideCookieBanner: () => void;
  setCBConsent: (c: boolean) => void;
}

export const useCookieBannerStore = create<CookieBannerStoreI>((set) => ({
  isCBVisible: localStorage.getItem(COOKIE_LOCAL_STORAGE_ID) === null,
  hasConsent: localStorage.getItem(COOKIE_LOCAL_STORAGE_ID) === "accepted",
  showCookieBanner: () => set({ isCBVisible: true }),
  hideCookieBanner: () => set({ isCBVisible: false }),
  setCBConsent: (c) => set({ hasConsent: c }),
}));
